module.exports = __webpack_public_path__ + "static/media/NYIT_logo.010adf08.png";